import React from 'react';

import CustomSpinner, { CustomSpinnerColor } from '@components/Spinner/CustomSpinner';
import PriceBreakdown from '@components/pages/Subscribe/Forms/PriceBreakdown';

import styles from './styles.module.scss';

interface PriceBreakdownProps {
  isLoadingConfirmGroupSubscription: boolean;
  totalTaxAmount: number;
  totalCostWithoutTax: number;
  totalCostWithTax: number;
}

const CostSummary = ({
  isLoadingConfirmGroupSubscription,
  totalTaxAmount,
  totalCostWithoutTax,
  totalCostWithTax,
}: PriceBreakdownProps) => (
  <div>
    {isLoadingConfirmGroupSubscription ? (
      <CustomSpinner color={CustomSpinnerColor.PrimaryMagenta} />
    ) : (
      <div>
        <PriceBreakdown
          taxAmount={totalTaxAmount}
          currentPrice={totalCostWithoutTax}
          isSingleCharge
        />

        <div className={styles.totalWithTaxContainer}>
          <div>Total:</div>
          <div>${totalCostWithTax.toFixed(2)}</div>
        </div>
      </div>
    )}
  </div>
);

export default CostSummary;
